import axios from 'axios';
import client from './client';
import { getStoredToken } from '@/auth/localToken';
import type { AuthConfig, ChangePasswordResponse, LocalLoginResponse, UserProfile } from '@/types';

/** Public — no Bearer required. */
export async function getAuthConfig() {
  const { data } = await axios.get<AuthConfig>('/api/v1/auth/config');
  return data;
}

export async function loginLocal(email: string, password: string) {
  const { data } = await axios.post<LocalLoginResponse>('/api/v1/auth/local/login', {
    email,
    password,
  });
  return data;
}

export async function changePassword(newPassword: string) {
  const token = getStoredToken();
  const { data } = await client.post<ChangePasswordResponse>(
    '/auth/local/change-password',
    { new_password: newPassword },
    {
      headers: token ? { Authorization: `Bearer ${token}` } : {},
    },
  );
  return data;
}

export async function fetchMe() {
  const token = getStoredToken();
  const { data } = await axios.get<UserProfile>('/api/v1/auth/me', {
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
  return data;
}

export async function logoutServer() {
  try {
    await client.post('/auth/logout');
  } catch {
    /* best-effort */
  }
}
